export const BASEURL = window.location.hostname.includes("localhost") ? process.env.REACT_APP_LOCAL_BACKEND_URL : process.env.REACT_APP_LIVE_BACKEND_URL;

export const timeZone = "Asia/Kolkata";
export const dashboardName = "Subscription App";